import React, { FunctionComponent, ReactNode } from 'react';
import { TypographyVariant, Label, Tooltip, AnalyticsProps } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// components
import CommonIcon from './CommonIcon';

// styled components
import { BlueTypography } from './SharedStyledElements';

export const InlineTypography = styled(BlueTypography)`
  display: inline-flex;
`;

const Container = styled.div<AnalyticsProps>`
  display: flex;
  align-items: center;
  cursor: pointer;

  div {
    margin-top: 0.2rem;
  }
`;

const LabelTooltip = styled(Tooltip)`
  [tooltip] {
    position: absolute;
    top: 0.5rem;
  }
`;

export enum IconPositions {
  RIGHT = 'right',
  LEFT = 'left',
}

enum LabelVariants {
  LABEL = 'label',
}

type LabelVariant = 'label';

type ExtendedTypographyVariant = TypographyVariant | LabelVariant;

type IconPosition = 'left' | 'right';

interface Props extends AnalyticsProps {
  title: string;
  icon: string;
  variant: ExtendedTypographyVariant;
  htmlFor?: string;
  iconPosition?: IconPosition;
  tooltipContent?: string;
  children?: ReactNode;
}

const TitleWithIcon: FunctionComponent<Props> = ({
  title,
  variant,
  icon,
  htmlFor,
  iconPosition = IconPositions.LEFT,
  tooltipContent,
  children,
  tag = '',
}) => {
  const renderTitle = () => {
    if (children) {
      return children;
    }

    if (variant === LabelVariants.LABEL) {
      return <Label htmlFor={htmlFor}>{title}</Label>;
    }

    return <InlineTypography variant={variant}>{title}</InlineTypography>;
  };

  return (
    <Container tag={tag}>
      {iconPosition === IconPositions.LEFT && <CommonIcon name={icon} />}
      {renderTitle()}
      {iconPosition === IconPositions.RIGHT && tooltipContent && (
        <LabelTooltip tag={`label_${tag}`} placement="right" content={tooltipContent}>
          <CommonIcon name={icon} isLabelIcon />
        </LabelTooltip>
      )}
    </Container>
  );
};

export default TitleWithIcon;
